module.exports = __webpack_public_path__ + "06_hair_black.29e32c32.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/06_hair_black.png
// module id = hzh+
// module chunks = 0